var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72 10.832c5.154-2.37 8.59-3.934 10.31-4.689 4.91-2.156 5.93-2.53 6.595-2.543.146-.002.474.036.685.217.18.153.228.36.252.506.023.145.053.476.03.735-.267 2.951-1.418 10.114-2.003 13.42-.248 1.399-.736 1.868-1.209 1.914-1.026.1-1.806-.717-2.8-1.405-1.556-1.077-2.435-1.747-3.946-2.798-1.745-1.215-.614-1.882.38-2.973.261-.286 4.785-4.63 4.872-5.024.011-.05.021-.233-.082-.33-.103-.097-.256-.064-.366-.037-.156.037-2.642 1.772-7.457 5.204-.706.511-1.345.76-1.918.748-.63-.015-1.845-.377-2.748-.687-1.107-.38-1.987-.581-1.91-1.226.04-.337.478-.68 1.315-1.032Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c43e9cbb8a2c5639d6373bc355dd5891.svg";
export { ForwardRef as ReactComponent };